import loadable from '@loadable/component'

const FeaturePage = loadable(() => import('./Feature'))
const HomePage = loadable(() => import('./Home'))
const PricingPage = loadable(() => import('./Pricing'))
const UseCasePage = loadable(() => import('./UseCase'))

export { FeaturePage, HomePage, PricingPage, UseCasePage }
